import { Button, Col, Form, Input, Row, Space, Spin, Table, Typography } from 'antd';
import { ExpandSearch, InputFields, ListActionButton } from 'components/common';
import React, {useState, useRef, useEffect} from 'react';
import { cardTypesInfo, columns, dataFields } from './config';
import Icons from 'assets/icons';
import {cardTypesService} from 'api';
import './CardTypes.scss';
import ServiceTable from './ServiceTable/ServiceTable';
import Notification from 'components/common/notification/notification';
import { dataField } from 'pages/Receive/ReportOPD/ReportOPD.config';
import { formatDateToString } from 'helper/common';
import { FORMAT_TIME } from 'types/enums';

const CardTypes = () => {
  const [loading, setLoading] = useState<any>(false);
  const sTRef = useRef<any>();
  const initialValues = {
  }
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [params, setParams] = useState<any>([]);
  const [form] = Form.useForm();
  const [detailForm] = Form.useForm();
  const [cardTypes, setCardTypes] = useState<any>(null);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [saveType, setSaveType] = useState<number>(1);
  const onPageChange = async (pg, pgSize) => {
    setPage(pg)
    setLimit(pgSize)
    fetchListCardTypes({
      ...params,
      page: pg,
      limit: pgSize
    })
  }

  const handleFormChange = (changedValues, allValues) => {
    setParams({...allValues})
  }
  const fetchListCardTypes = async (params) => {
    try {
      setLoading(true)
      let response = await cardTypesService.getListCardTypes(params);
      setCardTypes(response)
      setLoading(false)
    } catch (err) {
      
      setLoading(false)
    }
  }
  const onFinish = async (values) => {
    fetchListCardTypes({
      ...values,
      page: page,
      limit: limit,
      start:formatDateToString(params.start,FORMAT_TIME.dayFull),
      end:formatDateToString(params.end,FORMAT_TIME.dayFull),
    })
  }
  const resetSearch = async (values) => {
    form.resetFields();
    setParams(initialValues);
    fetchListCardTypes({
      ...initialValues,
      page: page,
      limit: limit,
      start:formatDateToString(params.start,FORMAT_TIME.dayFull),
      end:formatDateToString(params.end,FORMAT_TIME.dayFull),
    })
  }
  const onAddCardTypes = async () => {
    detailForm.resetFields()
    sTRef.current.setData([])
    setSaveType(0);
  }
  const editFunc = async (record) => {
    setCurrentRecord({
      ...record
    });
    setSaveType(1)
  }
  const printFunc = async (record) => {

  }
  const delFunc = async (record) => {
    try {
      let response = await cardTypesService.delCardTypes({
        id: record.id
      })
      Notification("success", "Đã xoá!")
      fetchListCardTypes({
        ...params,
        page: page,
        limit: limit
      })
    } catch (err) {
      
    }
  }
  const onSave = async (type) => {
    detailForm.validateFields().then(async values => {
      if(!(await sTRef.current?.validateFields())) {
        Notification("warning", "Hãy nhập đủ thông tin về dịch vụ thẻ!");
        return;
      }
      if(type === 1) {
        
        if(values.id === null || values.id === undefined) {
          Notification("error", "Hãy chọn loại thẻ cần cập nhật trước!");
          return;
        }
        let dichVus = sTRef.current.getData();
        let data = {
          ...values,
          dichVuTrongThes: dichVus.map(it => ({
            ...it,
            idLoaiThe: values.id
          }))
        }
        try {
          let response = await cardTypesService.putCardTypes(data)
          Notification("success", "Cập nhật thành công!")
          fetchListCardTypes({
            ...params,
            page: page,
            limit: limit
          })
        }
        catch (err) {
          
        }
      }
      else if (type === 0) {
        let dichVus = sTRef.current.getData();
        let data = {
          ...values,
          dichVuTrongThes: dichVus.map(it => ({
            ...it,
          }))
        }
        try {
          let response = await cardTypesService.postCardTypes(data)
          Notification("success", "Thêm mới thành công!")
          fetchListCardTypes({
            ...params,
            page: page,
            limit: limit
          })
          setSaveType(1);
        }
        catch (err) {
          Notification("error", "Lỗi xảy ra khi thêm mới!")
        }
      }
    })
  }

  columns.map(it => {
    if(it.dataIndex === 'action') {
      it.render = (v, r, i) => {
        return <ListActionButton 
          editFunction={() => editFunc(r)}
          deleteFunction={() => delFunc(r)}
        />
      }
    }
  })
  const onRowChange = async (selectedRowKeys, selectedRows, info) => {
    setCurrentRecord(selectedRows[0]);
    setSaveType(1);
  }

  useEffect(() => {
    fetchListCardTypes({
      page: 1,
      limit: 10
    })
  }, [])
  useEffect(() => {

  }, [cardTypes])
  useEffect(() => {
    if(currentRecord) {
      detailForm.resetFields();
      detailForm.setFieldsValue({
        ...currentRecord,
      })
      sTRef.current?.setData(currentRecord.dichVuTrongThes.map((it, index) => ({
        key: index + 1,
        ...it
      })))
    }
  }, [currentRecord])
  return (
    <Spin spinning={loading}>
      <div className='card-types'>
        <div className='container'>
          <Form form={form} onFinish={onFinish} initialValues={initialValues} onValuesChange={handleFormChange}>
            <Row gutter={[8, 8]}>
              <InputFields data={dataFields}/>
              <Row justify={'end'}>
                <Form.Item>
                  <Row style={{gap: '4px'}}>
                    <Button type='ghost' className='btn-sub' icon={<Icons.reload />} onClick={resetSearch}>Xoá tìm kiếm</Button>
                    <Button type='primary' icon={<Icons.search />} htmlType='submit'>Tìm kiếm</Button>
                  </Row>
                </Form.Item>
              </Row>
            </Row>
          </Form>
        </div>
        <Row gutter={[8, 0]}>
          <Col xs={24} sm={24} md={24} lg={10} xl={10}>
            <div className='container'>
              <Row justify={'end'} style={{marginBottom: '4px'}}>
                <Button type='primary' icon={<Icons.add />} onClick={onAddCardTypes}>Thêm</Button>
              </Row>
              <Row>
                <Table
                  rowKey={record => record.id}
                  loading={loading}
                  columns={columns}
                  dataSource={cardTypes ? cardTypes.data : []}
                  pagination={{
                    position: ["bottomRight"],
                    showSizeChanger: true,
                    total: cardTypes?.total,
                    pageSize: cardTypes?.limit,
                    current: cardTypes?.page,
                    onChange: onPageChange
                  }}
                  onRow={(record) => ({
                    onDoubleClick: () => editFunc(record),
                  })}
                  bordered
                  rowSelection={{
                    type: "radio",
                    onChange: onRowChange
                  }}
                />
              </Row>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={14} xl={14}>
            <div className='container'>
              <Form form={detailForm} onFinish={onSave}>
                <Space direction='vertical'>
                  <Row justify={'space-between'} style={{marginBottom: '4px'}}>
                    <Typography.Text strong>
                      Chi tiết loại thẻ khám
                    </Typography.Text>
                    <Form.Item>
                      <Button type='primary' icon={<Icons.save />} onClick={() => onSave(saveType)}>Lưu</Button>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Row gutter={[8, 8]}>
                      <InputFields data={cardTypesInfo} />
                    </Row>
                  </Row>
                  <Row>
                    <ServiceTable ref={sTRef}/>
                  </Row>
                </Space>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};

export default CardTypes;